import { axios, baseURL } from "./axios.dashboard"

const getIllustrationFolders = async () => {
    return await axios
        .get( baseURL+"illustrations")
        .then((response) => {
            return response
        }).catch((e) => {
            return e.response.data
        })
}

const getIllustrationInFolders = async (id) => {
    return await axios
        .get( baseURL+"illustrations/"+id)
        .then((response) => {
            return response
        }).catch((e) => {
            return e.response.data
        })
}

const downloadIllustration = async (id) => {
    return await axios
        .get( baseURL+"illustration/"+id)
        .then((response) => {
            return response
        }).catch((e) => {
            return e.response.data
        })
}

export {downloadIllustration, getIllustrationInFolders, getIllustrationFolders}